<template>
  <CustomModal title="Cancelar Selos"
               :show="show"
               size="xl"
               @closeModal="close"
               @ok="confirm">
    <div>
      <h4>
        Custa: {{ item.custa.ato }}
      </h4>
      <span class="mt-2">Quantidade Selos: {{ item.seloItemOs && item.seloItemOs.length || 0 }}</span>
    </div>
    <div v-if="show"
         class="container mt-5">
      <table class="table">
        <thead>
          <tr>
            <th>Número do Selo</th>
            <th>Observação</th>
            <th>Ação</th>
            <th>Número da Ordem Judicial</th>
          </tr>
        </thead>
        <tbody>
          <!-- Início do loop para cada item de selo -->
          <tr v-for="itemSelo of item.seloItemOs"
              :key="`list_selos_${ itemSelo.selo.num_selo }`"
              class="text-left mt-4">
            <td>{{ itemSelo.selo.num_selo }}</td>
            <td>
              <small v-if="verifyTimeDiff(itemSelo.selo)"
                     class="text-primary">- Criado a mais de 72h.</small>
              <small v-else>Criado a menos de 72h</small>
            </td>
            <td class="d-flex justify-content-between">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  :id="`excluir_${_uid}_${itemSelo.selo.num_selo}`"
                  v-model="itemSelo.selo.excluirSelo"
                  v-validate="{ required: true }"
                  type="radio"
                  :name="`name_${itemSelo.selo.num_selo}`"
                  value="deleteds"
                  class="custom-control-input"
                  :class="{'is-invalid': errors.has(`name_${itemSelo.selo.num_selo}`)}"
                  @change="seloModalAction(itemSelo, 'deleteds')">
                <label
                  class="custom-control-label"
                  :for="`excluir_${_uid}_${itemSelo.selo.num_selo}`"><small>Excluir</small></label>
              </div>

              <div class="custom-control custom-radio custom-control-inline">
                <input
                  :id="`cancelar_${_uid}_${itemSelo.selo.num_selo}`"
                  v-model="itemSelo.selo.cancelarSelo"
                  v-validate="{ required: true }"
                  type="radio"
                  :name="`name_${itemSelo.selo.num_selo}`"
                  value="canceleds"
                  class="custom-control-input"
                  :class="{'is-invalid': errors.has(`name_${itemSelo.selo.num_selo}`)}"
                  @change="seloModalAction(itemSelo, 'canceleds')">
                <label
                  class="custom-control-label"
                  :for="`cancelar_${_uid}_${itemSelo.selo.num_selo}`"><small>Cancelar</small></label>
              </div>
            </td>
            <td>
              <CustomInput v-if="itemSelo.selo.cancelarSelo"
                           placeholder="Digite o número da ordem judicial aqui..."
                           mask-type="selo"
                           validate-type="selo"
                           @setError="setError"
                           @blur="(name, value) => itemSelo.selo.num_ordem_judicial = value" />
            </td>
          </tr>
          <!-- Fim do loop para cada item de selo -->
        </tbody>
      </table>
    </div>
  </CustomModal>
</template>

<script>
  import OrdemServicoItem from "@/entities/OrdemServicoItem/OrdemServicoItem.js"
  import { UseCaseSelo } from '@/entities/Selo/UseCaseSelo.js'
  import CustomButton from '@/components/CustomButton/CustomButton.vue'
  import CustomInput from '@/components/CustomInputs/CustomInput.vue'
  import CustomModal from '@/components/CustomModal/CustomModal.vue'
  // Utils
  import { displayQuestion } from '@/utils/displayQuestion.js'

  import moment from "moment"
  export default {
    name: 'CancelarSelosOs',
    components: {
      CustomButton,
      CustomInput,
      CustomModal
    },
    props: {
      show: {type: Boolean, default: false},
      itemOs: {type: Object, default: () => {} },
      indexItemOs: {type: Number, default: null}
    },
    data () {
      return {
        item: null,
        itemChanged: false,
      }
    },
    watch: {
      itemOs () {
        if (this.itemOs?.ordem_servico_item_id) this.item = this.itemOs
      }
    },
    created () {
      this.item = new OrdemServicoItem(this.itemOs)
    },
    methods: {
      getDiffHours (date) {
        return moment().diff(date, 'hours')
      },
      verifyTimeDiff (selo) {
        // pegamos a data_envio_tj d
        const { data_envio_tj } = selo

        return this.getDiffHours(data_envio_tj) > 72
      },
      seloModalAction (item, value) {
        if (value === 'deleteds') {
          item.selo.cancelarSelo = false
          item.selo.excluirSelo = true
        } else {
          item.selo.cancelarSelo = true
          item.selo.excluirSelo = false
        }

      },
      close () {
        this.$emit('close', this.indexItemOs)
      },
      async confirm () {
        const qtSelos = this.item?.seloItemOs.length
        const validate = this.item.seloItemOs.filter((obj) => obj.selo.excluirSelo === true || obj.selo.cancelarSelo === true )

        if (qtSelos !== validate.length) {
          return displayMessage('error', 'Atenção!', 'Para continuar deve-se escolher uma opção para cada selo')
        }
        try {
          const questionText = 'Você realmente deseja excluir o selo? Exclusões após 72h úteis podem gerar sanções para seu cartório.'
          const question = await displayQuestion('Atenção', questionText, 'Sim', 'Não')
          if (!question) return
          this.item.flag_cancelado = true
          this.$emit('confirm', this.item)
        } catch (error) {
          displayMessage('error', 'Erro!', 'Erro ao cancelar selo, tente novamente em alguns instantes')
        }
      },

    }
  }
</script>

<style lang="scss" scoped>
  // @import '@/scss/_utilities/_exports';

</style>
